import React from 'react';
import { Box, capitalize, Stack, Typography } from '@mui/material';
import { IDateDivider } from './interfaces';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { formatLocaleDate } from '@helpers/dateHelpers';

export const DateDivider: React.FC<IDateDivider> = ({
  date,
  sx,
}): JSX.Element => {
  return (
    <Stack
      direction="row"
      gap="5px"
      alignItems="center"
      sx={{
        mb: '10px',
        ...sx,
      }}
    >
      <CalendarMonthIcon
        sx={{
          color: '#95a5a6',
        }}
      />
      <Typography variant="body2" fontWeight="bold" color="text.secondary">
        {capitalize(formatLocaleDate(date, false, true))}
      </Typography>
      <Box
        sx={{
          borderBottom: '2px solid #95a5a6',
          flex: 1,
        }}
      />
    </Stack>
  );
};
